import { Animatespin, Footer, Navbar } from "../../components/index";
import ImageGallery from "react-image-gallery";
import Functions from "./index.functions";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";
import Modal from "react-modal"; // or use your own modal
import DOMPurify from "dompurify";
Modal.setAppElement("#root");
const ProjectDetails = () => {
  const {
    isLoading,
    project,
    localimgpath,
    openGallery,
    isOpen,
    closeGallery,
    galleryImages,
    selectedIndex,
  } = Functions();
  return (
    <div className="bg-primary">
      <div className="relative">
        <div className="absolute top-0 left-0 w-full z-10">
          <Navbar />
          {isLoading ? (
            <Animatespin />
          ) : (
            <div className="flex justify-start items-center lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:h-40 sm:h-80 lg:h-[88vh]">
              <div>
                <div>
                  <h1 className="uppercase text-secondary font-unboundedSemiBold lg:text-5xl lg:leading-tight">
                    {/* {project?.heading?.split(" ")[0]} <br /> {project?.heading?.split(" ")[1]} */}
                    {project?.heading}
                  </h1>
                </div>
                <div>
                  <p className="text-secondary font-onestMedium lg:text-xl">
                    {project?.sub_heading}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          <img
            className=" w-full xs:h-60 sm:h-96 lg:h-screen"
            src={`${localimgpath?.projectsBanner}/${project?.banner}`}
            alt={project?.real_name}
          />
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-black/90 to-transparent " />
        </div>
      </div>
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:pt-5 sm:py-16 lg:pt-14 text-white">
        <div className="">
          <h2 className="text-secondary font-unboundedMedium lg:text-2xl xs:mb-1.5 sm:mb-2 lg:mb-3.5">
            Description
          </h2>
          <div
            className="prose text-secondary font-onestLight xs:mb-1 xs:text-xs sm:text-xs xl:mb-4 lg:mb-2 sm:mb-2 xl:text-base lg:text-sm"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(project?.description),
            }}
          />
        </div>
        {/* <div className=" text-white py-10">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-left">
                        <div>
                            <p className="font-onestMedium xs:text:sm sm:text-lg">Genre/Duration</p>
                            <span className="xs:text-xs sm:text-sm font-onestLight">Animation | 01 hr 30 min</span>
                        </div>
                        <div>
                            <p className="font-onestMedium xs:text:sm sm:text-lg">Rating</p>
                            <span className="xs:text-xs sm:text-sm font-onestLight">U</span>
                        </div>
                        <div>
                            <p className="font-onestMedium xs:text:sm sm:text-lg">Language</p>
                            <span className="xs:text-xs sm:text-sm font-onestLight">Urdu</span>
                        </div>
                        <div>
                            <p className="font-onestMedium xs:text:sm sm:text-lg">Director</p>
                            <span className="xs:text-xs sm:text-sm font-onestLight">Uzair Zaheer Khan</span>
                        </div>
                    </div>
                </div> */}

        <div>
          {project?.galleries?.length === 0 ? (
            <></>
          ) : (
            <div className="lg:py-3 xs:pb-2">
              <h2 className="text-secondary font-onestMedium lg:text-2xl">
                Gallery
              </h2>
              <div className="lg:pt-10 sm:pt-6 xs:py-5 xs:pb-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-2.5">
                {project?.galleries?.map((Item, index) => (
                  <div
                    key={`${index}`}
                    onClick={() => openGallery(index)}
                    className="cursor-pointer w-full h-[250px] sm:h-[200px] lg:h-[250px] xl:h-[350px]"
                  >
                    <img
                      src={`${localimgpath?.projectsGallery}/${Item?.image}`}
                      className="w-full h-full"
                      alt="Gallery"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <Modal
          isOpen={isOpen}
          onRequestClose={closeGallery}
          contentLabel="Image Gallery Modal"
          className="w-full mx-0 sm:mx-auto p-4 sm:p-6 bg-primary rounded-lg shadow-xl overflow-y-auto"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        >
          <button
            onClick={closeGallery}
            className="absolute top-2 right-2 text-white text-xl z-10"
          >
            ✕
          </button>

          <ImageGallery
            items={galleryImages}
            startIndex={selectedIndex}
            showPlayButton={false}
            showFullscreenButton={true}
            showThumbnails={true}
            showIndex={true}
          />
        </Modal>
      </div>
      <Footer />
    </div>
  );
};
export default ProjectDetails;
